export const COLOR_FONT_POINT = '#95AFE7';
export const COLOR_FONT = '#000000';
export const COLOR_FONT_GRAY = '#B6B6B6';
export const COLOR_BORDER = '#E4E4E4';
export const COLOR_GREEN = '#6FCF97';
export const COLOR_RED = '#FF9797';
export const COLOR_WHITE = '#FFFFFF';
